import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import './solutionsStyles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import ServicesScreenshot from '../../img/services-screen.jpg';
import solutionsClasses from './solutionsStyles.js'


function OurSolutionsServices() {
  const globalClasses = globalUseStyles()
  const solutionsStyles = solutionsClasses()

  return (
    <ThemeProvider theme={theme}>
        <Container className={"servicesStyle"} maxWidth={false} component="section">
            <Container className={"servicesStyleInner"} maxWidth={false} component="section">
                <Grid className={globalClasses.containerSmall} item xs={12} md={12} container >
                    <Grid className={globalClasses.cardInner} item xs={12} md={12}  >
                        <Typography  align="center" variant="subtitle1">What We Do</Typography>
                        <Typography  align="center" variant="h2">Our Services</Typography>
                        <Typography  align="center" variant="body1">We bring innovation and technological advancement to government projects. With a robust skill set, collaborative team structure, and flexible project frameworks, we are prepared to tackle any challenge. </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} >
                        <img src={ServicesScreenshot} alt="screenshot" className={globalClasses.imageTreatment}/>   
                    </Grid>
                <Grid className={globalClasses.textBlock} item xs={12} sm={12} md={8} container >
                    <Grid className={solutionsStyles.servicesList} item xs={12} md={6}>
                        <Typography className={globalClasses.noMarginBold} variant="body1">Product Strategy</Typography>
                        <Typography variant="body2">An iterative plan and approach to product development. </Typography>
                    </Grid>
                    <Grid className={solutionsStyles.servicesList} item xs={12} md={6}>
                        <Typography className={globalClasses.noMarginBold} variant="body1">Analytics</Typography>
                        <Typography variant="body2">Business Intelligence Analytics across Power BI and Tableaux. </Typography>
                    </Grid>
                    <Grid className={solutionsStyles.servicesList} item xs={12} md={6}>
                        <Typography className={globalClasses.noMarginBold} variant="body1">Product Management</Typography>
                        <Typography variant="body2">Technical product management and expertise in agile methodology.  </Typography>
                    </Grid>
                    <Grid className={solutionsStyles.servicesList} item xs={12} md={6}>
                        <Typography className={globalClasses.noMarginBold} variant="body1">Development</Typography>
                        <Typography variant="body2">High quality software using modern technology within an agile methodology.  </Typography>
                    </Grid>
                    <Grid className={solutionsStyles.servicesList} item xs={12} md={6}>
                        <Typography className={globalClasses.noMarginBold} variant="body1">Design</Typography>
                        <Typography variant="body2">Data-driven, user-centered design methodologies, including user research, prototyping and visual design. </Typography>
                    </Grid>
                    <Grid className={solutionsStyles.servicesList} item xs={12} md={6}>
                        <Typography className={globalClasses.noMarginBold} variant="body1">Dev Ops</Typography>
                        <Typography variant="body2">Cloud native processes combining software development and IT operations.</Typography>
                    </Grid>
                </Grid>
                </Grid>
            </Container>
        </Container>
    </ThemeProvider>
  );
};

export default OurSolutionsServices;